import { GameTitle } from "./plugin/index.js";
import "./styles.css";

export { GameTitleCommands } from "./commands/index.js";

export default GameTitle;
